var MatchStats = function() {
    return {
        registerBtnHandlers: function() {
            $('.ii__stats_expand_btn').click(function() {
                $('.ii__more_stats_container').collapse();
                $('.ii__stats_expand_btn').hide();
            });
            $('.ii__stats_period_btn').click(function() {
                let btn = $(this);
                $('.ii__stats_period_btn').removeClass('abox__btn--active');
                btn.addClass('abox__btn--active');
                let period = btn.data('period');
                $('#match_stats_container').data('sel_period', period);
                $('.ii__stats_period_container').hide();
                $(`.ii__stats_period_container_${period}`).show();
            });
        },
        refresh: function(mid) {
            let match_stats_container = $('#match_stats_container');
            let expanded = $('.ii__more_stats_container').toArray().some((el) => $(el).hasClass('show')) ? 1 : 0;
            let selected_period = match_stats_container.data('sel_period');
            Ajax.getMatchStats(mid, expanded, selected_period, function(res) {
                if (res.success == 'ok' && res.html) {
                    if (match_stats_container.length) {
                        match_stats_container.replaceWith(res.html);
                    } else {
                        let container_div = Generic.mobile ? $(`#match-${mid}`) : $('#general .row:first-child > :nth-child(2)');
                        container_div.html(res.html + container_div.html());
                    }
                    MatchStats.registerBtnHandlers();
                }
            });
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = MatchStats;
}
